import { createLogger } from './logger';

const logger = createLogger('localStorageUtils');

export const localStorageUtils = {
  setItem: (key: string, value: any): void => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      logger.warn('localStorage setItem failed:', error);
    }
  },

  getItem: (key: string): any => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      logger.warn('localStorage getItem failed:', error);
      return null;
    }
  },

  removeItem: (key: string): void => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      logger.warn('localStorage removeItem failed:', error);
    }
  }
};

export const getSystemThemePreference = (): 'light' | 'dark' => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return 'light';
};
